import React, {PureComponent} from 'react';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

@inject('mcqSessionStore')
@observer
export class Question extends PureComponent {
  render() {
    const { mcqSessionStore, isSubmitedQuestion } = this.props;
    const { question, changeAnswerIndex, answerIndex } = mcqSessionStore;

    return (
      <div className="quiz-wrapper mcq-question">
        <h3 className='mcq-question-question'>{question.question}</h3>
        <div>
          <div style={{margin: '16px 0'}}>
            {isSubmitedQuestion ? (
              <RadioButtonGroup
                name="correct"
                className='quiz-answers'
                onChange={(e, newValue) => changeAnswerIndex(newValue)}
                valueSelected={answerIndex}
              >
                {(question.options || []).map((option, key) => (
                  <RadioButton
                    key={key}
                    value={key}
                    disabled
                    label={option.body}
                    className={`answer-option-wrapper ${key === answerIndex || option.correct ? (option.correct ? 'correct' : 'incorrect') : ''}`}
                  />
                ))}
              </RadioButtonGroup>
            ) : (
            <RadioButtonGroup
              name="correct"
              className='quiz-answers'
              onChange={(e, newValue) => changeAnswerIndex(newValue)}
              valueSelected={answerIndex}
            >
              {(question.options_without_correct || []).map((option, key) => (
                <RadioButton
                  key={key}
                  value={key}
                  label={option.body}
                  className='answer-option-wrapper'
                />
              ))}
            </RadioButtonGroup>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/mcq/components/Question.js